export default __webpack_public_path__ + "static/R1-45107e75ee48e03ebd5082df68f98411.png";